// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Muli-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Muli-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Muli-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Muli-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/CursedTimerUlil-Aznm.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/Silka-Black.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/Silka-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/Silka-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fonts/Silka-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/fonts/RedHatDisplay-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/fonts/RedHatDisplay-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/fonts/RedHatDisplay-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./assets/fonts/RedHatDisplay-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./assets/fonts/RedHatDisplay-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./assets/fonts/OpenSans-VariableFont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./assets/fonts/Anton-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overscroll-behavior-y: none;
}

.row-2 {
  grid-row: 2;
}
.column-2 {
  grid-column: 2;
}

.silka-bold {
  font-family: Silka-Bold !important;
}

.silka-black {
  font-family: Silka-Black !important;
}

.silka-light {
  font-family: Silka-Light !important;
}

.silka-regular {
  font-family: Silka-Regular !important;
}

@font-face {
  font-family: "Muli-Black";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: local("Black"), local("Black"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Muli-Bold";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  src: local("Muli-Bold"), local("Muli-Bold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}

@font-face {
  font-family: "Muli-Regular";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  src: local("Muli-Regular"), local("Muli-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}

@font-face {
  font-family: "Muli-Light";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src: local("Muli-Light"), local("Muli-Light"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("Muli-Light");
}

@font-face {
  font-family: "CursedTimerUlil-Aznm";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  src: local("CursedTimerUlil-Aznm"), local("CursedTimerUlil-Aznm"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("CursedTimerUlil-Aznm");
}

@font-face {
  font-family: "Silka-Black";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: local("Black"), local("Black"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}

@font-face {
  font-family: "Silka-Bold";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src: local("Bold"), local("Bold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}
/* @font-face {
  font-family: "Silka-Regular";
  font-style: normal;
  src: url("./assets/fonts/Silka-Regular.otf");
  src: local("Regular"), local("Regular"),
    url(./assets/fonts/Silka-Regular.otf) format("truetype");
} */
@font-face {
  font-family: "Silka-Light";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  src: local("Light"), local("Light"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: "Silka-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

@font-face {
  font-family: "RedHatDisplay-Black";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  src: local("Black"), local("Black"),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
@font-face {
  font-family: "RedHatDisplay-Bold";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: local("RedHatDisplay-Bold"), local("RedHatDisplay-Bold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
}

@font-face {
  font-family: "RedHatDisplay-Regular";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  src: local("RedHatDisplay-Regular"), local("RedHatDisplay-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}

@font-face {
  font-family: "RedHatDisplay-Light";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  src: local("RedHatDisplay-Light"), local("RedHatDisplay-Light"),
    url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("truetype");
}

@font-face {
  font-family: "RedHatDisplay-Variable";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  src: local("RedHatDisplay-Variable"), local("RedHatDisplay-Variable"),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("truetype");
}

@font-face {
  font-family: "OpenSans-Variable";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  src: local("OpenSans-Variable"), local("OpenSans-Variable"),
    url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype");
}

@font-face {
  font-family: "Anton-Regular";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  src: local("Anton-Regular"), local("Anton-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("truetype");
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,4CAAyC;EACzC;8DACuD;AACzD;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,4CAAwC;EACxC;8DACsD;AACxD;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,4CAA2C;EAC3C;8DACyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,4CAAyC;EACzC;gEACyD;AAC3D;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,4CAAmD;EACnD;0EAC6E;AAC/E;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,4CAA0C;EAC1C;8DACwD;AAC1D;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,4CAAyC;EACzC;8DACuD;AACzD;AACA;;;;;;GAMG;AACH;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,4CAA0C;EAC1C;8DACwD;AAC1D;AACA;EACE,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,4CAAkD;EAClD;8DACgE;AAClE;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,6CAAiD;EACjD;+DAC+D;AACjE;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,6CAAoD;EACpD;+DACkE;AACpE;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,6CAAkD;EAClD;+DACgE;AAClE;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,6CAA8D;EAC9D;+DAC4E;AAC9E;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,6CAAoD;EACpD;+DACkE;AACpE;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,6CAA4C;EAC5C;+DAC0D;AAC5D","sourcesContent":["body {\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overscroll-behavior-y: none;\n}\n\n.row-2 {\n  grid-row: 2;\n}\n.column-2 {\n  grid-column: 2;\n}\n\n.silka-bold {\n  font-family: Silka-Bold !important;\n}\n\n.silka-black {\n  font-family: Silka-Black !important;\n}\n\n.silka-light {\n  font-family: Silka-Light !important;\n}\n\n.silka-regular {\n  font-family: Silka-Regular !important;\n}\n\n@font-face {\n  font-family: \"Muli-Black\";\n  font-style: normal;\n  src: url(\"./assets/fonts/Muli-Black.ttf\");\n  src: local(\"Black\"), local(\"Black\"),\n    url(./assets/fonts/Muli-Black.ttf) format(\"truetype\");\n}\n@font-face {\n  font-family: \"Muli-Bold\";\n  font-style: normal;\n  src: url(\"./assets/fonts/Muli-Bold.ttf\");\n  src: local(\"Muli-Bold\"), local(\"Muli-Bold\"),\n    url(./assets/fonts/Muli-Bold.ttf) format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Muli-Regular\";\n  font-style: normal;\n  src: url(\"./assets/fonts/Muli-Regular.ttf\");\n  src: local(\"Muli-Regular\"), local(\"Muli-Regular\"),\n    url(./assets/fonts/Muli-Regular.ttf) format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Muli-Light\";\n  font-style: normal;\n  src: url(\"./assets/fonts/Muli-Light.ttf\");\n  src: local(\"Muli-Light\"), local(\"Muli-Light\"),\n    url(./assets/fonts/Muli-Light.ttf) format(\"Muli-Light\");\n}\n\n@font-face {\n  font-family: \"CursedTimerUlil-Aznm\";\n  font-style: normal;\n  src: url(\"./assets/fonts/CursedTimerUlil-Aznm.ttf\");\n  src: local(\"CursedTimerUlil-Aznm\"), local(\"CursedTimerUlil-Aznm\"),\n    url(./assets/fonts/CursedTimerUlil-Aznm.ttf) format(\"CursedTimerUlil-Aznm\");\n}\n\n@font-face {\n  font-family: \"Silka-Black\";\n  font-style: normal;\n  src: url(\"./assets/fonts/Silka-Black.otf\");\n  src: local(\"Black\"), local(\"Black\"),\n    url(./assets/fonts/Silka-Black.otf) format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Silka-Bold\";\n  font-style: normal;\n  src: url(\"./assets/fonts/Silka-Bold.otf\");\n  src: local(\"Bold\"), local(\"Bold\"),\n    url(./assets/fonts/Silka-Bold.otf) format(\"truetype\");\n}\n/* @font-face {\n  font-family: \"Silka-Regular\";\n  font-style: normal;\n  src: url(\"./assets/fonts/Silka-Regular.otf\");\n  src: local(\"Regular\"), local(\"Regular\"),\n    url(./assets/fonts/Silka-Regular.otf) format(\"truetype\");\n} */\n@font-face {\n  font-family: \"Silka-Light\";\n  font-style: normal;\n  src: url(\"./assets/fonts/Silka-Light.otf\");\n  src: local(\"Light\"), local(\"Light\"),\n    url(./assets/fonts/Silka-Light.otf) format(\"truetype\");\n}\n@font-face {\n  font-family: \"Silka-Regular\";\n  src: url(\"./assets/fonts/Silka-Regular.otf\");\n}\n\n@font-face {\n  font-family: \"RedHatDisplay-Black\";\n  font-style: normal;\n  src: url(\"./assets/fonts/RedHatDisplay-Black.ttf\");\n  src: local(\"Black\"), local(\"Black\"),\n    url(./assets/fonts/RedHatDisplay-Black.ttf) format(\"truetype\");\n}\n@font-face {\n  font-family: \"RedHatDisplay-Bold\";\n  font-style: normal;\n  src: url(\"./assets/fonts/RedHatDisplay-Bold.ttf\");\n  src: local(\"RedHatDisplay-Bold\"), local(\"RedHatDisplay-Bold\"),\n    url(./assets/fonts/RedHatDisplay-Bold.ttf) format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"RedHatDisplay-Regular\";\n  font-style: normal;\n  src: url(\"./assets/fonts/RedHatDisplay-Regular.ttf\");\n  src: local(\"RedHatDisplay-Regular\"), local(\"RedHatDisplay-Regular\"),\n    url(./assets/fonts/RedHatDisplay-Regular.ttf) format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"RedHatDisplay-Light\";\n  font-style: normal;\n  src: url(\"./assets/fonts/RedHatDisplay-Light.ttf\");\n  src: local(\"RedHatDisplay-Light\"), local(\"RedHatDisplay-Light\"),\n    url(./assets/fonts/RedHatDisplay-Light.ttf) format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"RedHatDisplay-Variable\";\n  font-style: normal;\n  src: url(\"./assets/fonts/RedHatDisplay-VariableFont_wght.ttf\");\n  src: local(\"RedHatDisplay-Variable\"), local(\"RedHatDisplay-Variable\"),\n    url(./assets/fonts/RedHatDisplay-VariableFont_wght.ttf) format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"OpenSans-Variable\";\n  font-style: normal;\n  src: url(\"./assets/fonts/OpenSans-VariableFont.ttf\");\n  src: local(\"OpenSans-Variable\"), local(\"OpenSans-Variable\"),\n    url(./assets/fonts/OpenSans-VariableFont.ttf) format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Anton-Regular\";\n  font-style: normal;\n  src: url(\"./assets/fonts/Anton-Regular.ttf\");\n  src: local(\"Anton-Regular\"), local(\"Anton-Regular\"),\n    url(./assets/fonts/Anton-Regular.ttf) format(\"truetype\");\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
